export default "__VITE_PUBLIC_ASSET__af462f66__"